export default "__VITE_PUBLIC_ASSET__07374dc0__"